import { Link } from "react-router-dom";

const POSTS = [
  {
    slug: "the-anatomy-of-a-perfect-bralette",
    title: "The anatomy of a perfect bralette",
    excerpt: "Not all lace is equal. A study of stretch, scallop, and the seam that changes everything.",
    date: "Feb 12, 2026",
    read: "6 min",
    tag: "Craft",
    image: "https://images.unsplash.com/photo-1568663521381-33b7c467fda0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxsYWNlJTIwYnJhJTIwbGluZ2VyaWV8ZW58MHx8fHwxNzgzMDgxMTU2fDA&ixlib=rb-4.1.0&q=85",
    body: [
      "There is a particular kind of alchemy in the making of a bralette. Between the stretch of the elastic and the scallop of the lace, between the seam that lays flat and the strap that never digs.",
      "We spent nine months developing the Étoile — cutting the pattern by hand, discarding fourteen prototypes, obsessing over a single 3mm hem. This is what we mean by considered.",
      "A perfect bralette is not designed to be seen. It is designed to be forgotten. To disappear against the skin until the moment it is chosen to be revealed.",
    ],
  },
  {
    slug: "silk-a-love-letter",
    title: "Silk — a love letter",
    excerpt: "On mulberry, momme, and the language of a fabric that has always known how to whisper.",
    date: "Feb 3, 2026",
    read: "4 min",
    tag: "Material",
    image: "https://images.unsplash.com/photo-1766056278976-87f269e3b69c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxzaWxrJTIwcm9iZSUyMHNsZWVwd2VhcnxlbnwwfHx8fDE3ODMwODExNTZ8MA&ixlib=rb-4.1.0&q=85",
    body: [
      "Silk does not ask to be admired. It waits. It moves the way a woman moves — slowly, with intention, catching the light and refusing to give it back.",
      "Our mulberry silk is woven in a small mill in Karnataka, where three generations of one family have been perfecting the same 19-momme weight for eighty years.",
      "There is nothing quite like the moment silk touches skin for the first time. It is a small, private surprise. A gift the wearer gives herself.",
    ],
  },
  {
    slug: "on-dressing-for-oneself",
    title: "On dressing for oneself",
    excerpt: "A meditation on the private gesture of getting ready before anyone else is looking.",
    date: "Jan 28, 2026",
    read: "5 min",
    tag: "Notes",
    image: "https://images.unsplash.com/photo-1750064139819-da3bf362e7b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxzaWxrJTIwcm9iZSUyMHNsZWVwd2VhcnxlbnwwfHx8fDE3ODMwODExNTZ8MA&ixlib=rb-4.1.0&q=85",
    body: [
      "The most elegant women in the world understand something simple: what is worn beneath sets the tone for what is worn above.",
      "There is a psychology to lingerie that resists articulation. It is not about seduction. It is about self-regard. About taking the private minutes of the morning as seriously as the ones the world will see.",
      "Ravishing is not something you become when you leave the house. It is something you already are, quietly, from the very first hook.",
    ],
  },
  {
    slug: "the-fit-that-changes-everything",
    title: "The fit that changes everything",
    excerpt: "A conversation with our head pattern-maker on why 4mm of difference matters.",
    date: "Jan 15, 2026",
    read: "7 min",
    tag: "Craft",
    image: "https://images.unsplash.com/photo-1642945680515-faada4c0ca7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxsYWNlJTIwYnJhJTIwbGluZ2VyaWV8ZW58MHx8fHwxNzgzMDgxMTU2fDA&ixlib=rb-4.1.0&q=85",
    body: [
      "Ask any woman what she looks for in lingerie and eventually the conversation lands on fit.",
      "Our head pattern-maker Amélie trained in Paris and cuts every base pattern by hand before it ever touches a machine. She talks about millimetres the way a jeweller talks about carats.",
      "'A bra that fits properly is invisible,' she says. 'The moment you notice it, we've already failed.'",
    ],
  },
];

export default function Journal() {
  return (
    <div data-testid="journal-page">
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 pt-16 pb-8">
        <div className="overline text-[#4A1525] mb-4">Journal</div>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl tracking-tighter max-w-3xl leading-[0.95]">
          Notes from<br/><em className="text-[#4A1525] font-light">the house.</em>
        </h1>
        <p className="text-[#5C5C5C] max-w-xl text-lg mt-6 leading-relaxed">
          Essays on craft, material, and the quiet philosophy behind our work.
        </p>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-2 gap-8 lg:gap-12">
        {POSTS.map((p) => (
          <Link key={p.slug} to={`/journal/${p.slug}`} className="group block" data-testid={`journal-card-${p.slug}`}>
            <div className="aspect-[4/5] overflow-hidden mb-6">
              <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="overline text-[#4A1525] mb-3">{p.tag} · {p.date} · {p.read}</div>
            <h2 className="font-serif text-3xl md:text-4xl leading-tight mb-3 group-hover:text-[#4A1525] transition-colors">{p.title}</h2>
            <p className="text-[#5C5C5C] leading-relaxed">{p.excerpt}</p>
            <div className="overline text-[#1A1A1A] mt-6 underline underline-offset-8 decoration-[#4A1525]">Read essay</div>
          </Link>
        ))}
      </section>
    </div>
  );
}

export function JournalPost() {
  const slug = window.location.pathname.split("/").pop();
  const post = POSTS.find(p => p.slug === slug);
  if (!post) {
    return (
      <div className="min-h-[60vh] flex flex-col items-center justify-center px-6 text-center">
        <p className="font-serif text-3xl mb-4">Essay not found</p>
        <Link to="/journal" className="overline underline underline-offset-4">← Back to journal</Link>
      </div>
    );
  }
  return (
    <div data-testid="journal-post-page">
      <article className="max-w-2xl mx-auto px-6 py-16 lg:py-24">
        <Link to="/journal" className="overline text-[#5C5C5C] hover:text-[#4A1525]" data-testid="back-to-journal">← Journal</Link>
        <div className="overline text-[#4A1525] mt-8 mb-4">{post.tag} · {post.date} · {post.read}</div>
        <h1 className="font-serif text-4xl md:text-6xl leading-tight mb-8">{post.title}</h1>
        <img src={post.image} alt={post.title} className="w-full aspect-[4/3] object-cover mb-10" />
        <div className="space-y-6 text-[#1A1A1A] leading-relaxed text-lg">
          {post.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </article>
    </div>
  );
}
